<template>
  <v-container>
    <v-row class="pb-4">
      <v-col>
        <v-icon> mdi-account-multiple-outline </v-icon>
        <span class="headline mx-2">{{ type.toUpperCase()==='HRM'?'Workspace':type.toUpperCase() }} Roles</span>
      </v-col>
    </v-row>
    <v-row
      v-if="loading" 
      class="fill-height"
      
      align="center" 
      justify="center"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </v-row>
    <v-row v-else>
      <v-col
        v-if="noOfRoles > 0"
      >
        <v-chip        
          v-for="role in roles"                       
          :key="role.id"
          class="ma-1"
        >
          {{ role.name }}
        </v-chip>      
      </v-col>
      <v-col v-else>
        <span class="mx-2"> No data available </span>
      </v-col>
    </v-row>
    <v-card-actions v-show="$hasPermissionTo(['update user roles'])">
      <v-spacer />
      <user-roles-dialog-edit        
        :type="type"
        :user-uid="userUid"
        @updated="loadUserRoles"
      />
    </v-card-actions>
  </v-container>
</template>

<script>
  export default {
    components: {
      UserRolesDialogEdit: () => import('@/components/user/roles/DialogEdit'),
    },
    props: {
      userUid: {
        type: String,
        required: true,
      },
      type: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        loading: false,
        progressing: false,
        roles: [],
      }
    },
    computed: {
      noOfRoles () {
        return this.roles.length
      },
    },
    watch: {
      userUid: {
        immediate: true,
        handler (value) {
          if (value) {
            this.$resetData()
            this.loadUserRoles()
          }
        },
      },
    },
    methods: {
      loadUserRoles () {
        this.loading = true

        if (this.type === 'workspace') {
          this.type = 'hrm'
        }
        
        this.$api.userRoles(this.type).list(this.userUid)
          .then((response) => {
            this.roles = response.data           
          })
          .catch(() => {})
          .then(() => {
            this.loading = false
          })
      },
    },
  }
</script>
